import { axios } from "./request";

/**
 * 后端请求工具
 *
 * @param url {string}
 * @param options {object} 配置参数，详见 https://github.com/mzabriskie/axios
 * @return {{}} 请求数据
 */
export function fetch (url, options = {}) {
  if (options.params) {
    Object.keys(options.params).forEach(e => {
      if (e === "id" && url.indexOf("{id}") > -1) {
        url = url.replace("{id}", options.params[e]);
        options.params[e] = undefined;
      }
    });
  }
  if (url.indexOf("http://www") === -1 && options.data) {
    Object.keys(options.data).forEach(e => {
      if (e === "id" && url.indexOf("{id}") > -1) {
        url = url.replace("{id}", options.data[e]);
        options.data[e] = undefined;
      }
    });
  }
  options = Object.assign(
    {
      url,
      method: options.method,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        ...options.headers
      }
      // transformRequest: [
      //   function transformRequest (data) {
      //     return JSON.stringify(data);
      //   }
      // ]
    },
    options
  );
  return axios(options);
}
